import "../../../assets/scss/docker-breadcrumb-style.scss";
import React, { useState } from "react";
import { BreadcrumbDividerIcon } from "../../icons/breadcrumbDividerIcon";

/* -------------------------------------------
   Path Utilities
-------------------------------------------- */
const getBreadcrumbParts = (folderPath: string) => {
  if (!folderPath || folderPath === "/") return [];

  const clean = folderPath.replace(/\/+$/, "");
  const parts = clean.split("/").filter(Boolean);
  // Example: folderPath="/logs/" => parts=["logs"]
  // Example: folderPath="/test/te_stss/" => parts=["test", "te_stss"]

  var fullPath = "";
  return parts.map(function (part) {
    fullPath += "/" + part;
    return {
      name: part,
      path: fullPath + "/",
    };
  });
};

/* -------------------------------------------
   BREADCRUMB COMPONENT
-------------------------------------------- */
interface BreadcrumbProps {
  folderPath: string;
  enterRoot: () => void;
  jumpToFolder: (path: string) => void;
  disabled?: boolean;
}

export const DockerBreadcrumb: React.FC<BreadcrumbProps> = ({
  folderPath,
  enterRoot,
  jumpToFolder,
  disabled,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const items = getBreadcrumbParts(folderPath);
  // Prepend root item for display
  var allItems = [{ name: "root", path: "" }].concat(items);
  var count = allItems.length;

  /* -------------------------------------------
       CASE 1: <= 3 levels => show all normally
  -------------------------------------------- */
  if (count <= 3) {
    return (
      <div className="docker-breadcrumb-container  normal">
        {allItems.map(function (item, idx) {
          return (
            <span key={idx} className="docker-breadcrumb-item">
              <button
                disabled={disabled}
                onClick={function () {
                  if (disabled) return;
                  if (item.path === "") enterRoot();
                  else jumpToFolder(item.path);
                }}
              >
                {item.path === "" ? "\u8CC7\u6599\u6E05\u55AE" : item.name}
              </button>
              {idx < allItems.length - 1 && (
                <span className="divider">
                  <BreadcrumbDividerIcon />
                </span>
              )}
            </span>
          );
        })}
      </div>
    );
  }

  /* -------------------------------------------
       CASE 2: > 3 levels => collapse middle
  -------------------------------------------- */
  var collapsed = allItems.slice(0, count - 2);
  var secondLast = allItems[count - 2];
  var last = allItems[count - 1];

  return (
    <div className="docker-breadcrumb-container">
      {/* Dropdown for "..." */}
      <div className="docker-breadcrumb-item docker-breadcrumb-dropdown">
        <button
          className="ellipsis"
          disabled={disabled}
          onClick={function () { if (!disabled) setShowDropdown(!showDropdown); }}
        >
          ...
        </button>

        {showDropdown && (
          <div className="dropdown-menu">
            {collapsed.map(function (item, idx) {
              return (
                <div
                  key={idx}
                  className="dropdown-item"
                  onClick={function () {
                    if (disabled) return;
                    setShowDropdown(false);
                    if (item.path === "") enterRoot();
                    else jumpToFolder(item.path);
                  }}
                >
                  <img
                    width="20"
                    style={{ marginRight: ".5em" }}
                    src={"./images/GoogleDriveBtn/folder.png"}
                  />
                  {item.path === "" ? "\u8CC7\u6599\u6E05\u55AE" : item.name}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <span className="divider">
        <BreadcrumbDividerIcon />
      </span>

      {/* second last */}
      <span className="docker-breadcrumb-item">
        <button disabled={disabled} onClick={function () { if (!disabled) jumpToFolder(secondLast.path); }}>
          {secondLast.name}
        </button>
      </span>

      <span className="divider">
        <BreadcrumbDividerIcon />
      </span>

      {/* last (active) */}
      <h2 className="docker-breadcrumb-item active">{last.name}</h2>
    </div>
  );
};
